export default "__VITE_ASSET__SPSnACaY__"